const elementEvents = {
	'defined': {
		step: 0,
		label: 'defined',
	},
	'received': {
		step: 2,
		label: 'received',
	},
	'loaded': {
		step: 3,
		label: 'loaded',
	},
	'rendered': {
		step: 4,
		label: 'rendered',
	},
	'rendered-empty': {
		step: 4,
		label: 'rendered-empty',
	},
	'viewable': {
		step: 5,
		label: 'viewable',
	},
	'destroyed': {
		step: 6,
		label: 'destroyed',
	}
};

/**
 * Given the main ad slot ID, ad the classname based on the event for itself and its wrapper.
 *
 * @param {String} adSlotID
 * @param {String} event The css class name to add.
 */
export const updateAdSlotEventClassName = ( adSlotID, event ) => {
	const element = document.querySelector( `#${adSlotID}` );

	if ( null !== element ) {
		// Remove the event based class name from the ad slot element and its parent node.
		updateElementEventClassName( element, event, 'ad-slot' );
		updateElementEventClassName( element.parentNode, event, 'ad-slot-wrapper' );
	}
}

/**
 * Given the element and details update it with the correct event based class name.
 *
 * @param {Object} element The element node.
 * @param {String} event The event as a string.
 * @param {String} classNameStart The start of the classname, i.e 'ad-slot' or 'ad-slot-wrapper'.
 */
const updateElementEventClassName = ( element, event, classNameStart ) => {

	// The element must contain 'ad-slot' or 'ad-slot-wrapper'.
	if ( element.classList.contains( classNameStart ) ) {

		const eventDetails = elementEvents[ event ];

		let currentStepNumber = parseInt( element.getAttribute( 'data-ad-slot-event-step-number' ) );

		if ( isNaN( currentStepNumber ) ) {
			currentStepNumber = 1;
		}

		function updateEl() {
			// Remove the event based class name from the ad slot element.
			element.classList.remove(
				`${ classNameStart }-destroyed`,
				`${ classNameStart }-defined`,
				`${ classNameStart }-received`,
				`${ classNameStart }-loaded`,
				`${ classNameStart }-rendered`,
				`${ classNameStart }-rendered-empty`,
				`${ classNameStart }-viewable`
			);

			element.setAttribute( 'data-ad-slot-event-step-number', eventDetails.step );
			element.setAttribute( 'data-ad-slot-event-step-label', eventDetails.label );

			// Add the current status from the event as a class name.
			element.classList.add( `${ classNameStart }-${event}` );
		}

		if ( eventDetails.step > currentStepNumber ||
			currentStepNumber === elementEvents.destroyed.step ) {
			updateEl();
		}
	}
}
